import React, {useState} from 'react';
import { Link } from 'react-router-dom';

import '../../interfaceSettings.css';
import GwinnettLogo from '../../assets/webp/ggc-light-logo.webp';
import { Navbar, Container, Nav, Offcanvas } from 'react-bootstrap';


const LandingNavbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen); // Toggle menu visibility
    };
    // HTML/JSX web page
    // TODO: Redesign page with necessary links for unsigned-in users. Remove extraneous hyperlinks.
    return (
        <Navbar expand="lg" className="navbar-custom mb-3">
            <Container fluid>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <img src={GwinnettLogo} alt="Gwinnett Logo" className="logo me-2" />
                    <span className="heading-gradient">WALKING TRAILS</span>
                </Navbar.Brand>

                {/* Mobile Menu Toggle Button */}
                <Navbar.Toggle
                    aria-controls="offcanvas-navbar"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="d-lg-none"
                />

                {/* Offcanvas for Mobile */}
                <Navbar.Offcanvas
                    id="offcanvas-navbar"
                    placement="end"
                    show={isMenuOpen}
                    onHide={() => setIsMenuOpen(false)}
                    className="d-lg-none"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link as={Link} to="/" onClick={() => setIsMenuOpen(false)}>
                                Home
                            </Nav.Link>
                            <Nav.Link as={Link} to="/about" onClick={() => setIsMenuOpen(false)}>
                                About
                            </Nav.Link>
                            <Nav.Link as={Link} to="/privacy" onClick={() => setIsMenuOpen(false)}>
                                Privacy
                            </Nav.Link>
                            <Nav.Link as={Link} to="/authorization" onClick={() => setIsMenuOpen(false)}>
                                Login
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>

                {/* Desktop Links (Inline) */}
                <Navbar.Collapse id="navbarNav" className="d-none d-lg-flex">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/" aria-label='Home'>Home</Nav.Link>
                        <Nav.Link as={Link} to="/about" aria-label='About'>About</Nav.Link>
                        <Nav.Link as={Link} to="/privacy" aria-label='Privacy'>Privacy</Nav.Link>
                        <Nav.Link as={Link} to="/authorization" aria-label='Login'>Login</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default LandingNavbar;